export const typings = {
  ApproveFundApplication: [],
  ApproveWithdrawalRequest: [
    {
      name: 'additionalInfo',
      type: 'string',
    },
  ],
  CancelWithdrawalRequest: [],
  CreateFundApplication: [
    {
      name: 'accountType',
      type: 'string',
    },
    {
      name: 'email',
      type: 'string',
    },
    {
      name: 'ownerName',
      type: 'string',
    },
    {
      name: 'ownerSurname',
      type: 'string',
    },
    {
      name: 'phone',
      type: 'string',
    },
    {
      name: 'telegram',
      type: 'string',
    },
  ],
  CreateFundEmployee: [
    {
      name: 'userAddress',
      type: 'address',
    },
    {
      name: 'email',
      type: 'string',
    },
    {
      name: 'firstName',
      type: 'string',
    },
    {
      name: 'lastName',
      type: 'string',
    },
    {
      name: 'middleName',
      type: 'string',
    },
    {
      name: 'avatar',
      type: 'string',
    },
  ],
  // Pool
  CreatePool: [
    {
      name: 'description',
      type: 'string',
    },
    {
      name: 'fundAddress',
      type: 'address',
    },
    {
      name: 'logo',
      type: 'string',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'riskFactor',
      type: 'string',
    },
    {
      name: 'type',
      type: 'string',
    },
  ],
  CreateWithdrawalRequest: [
    {
      name: 'amount',
      type: 'string',
    },
  ],
  DeclineFundApplication: [],
  DeletePool: [],
  DeployFundToChain: [
    {
      name: 'fundId',
      type: 'string',
    },
    {
      name: 'chainId',
      type: 'uint256',
    },
  ],
  EditPool: [
    {
      name: 'description',
      type: 'string',
    },
    {
      name: 'logo',
      type: 'string',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'riskFactor',
      type: 'string',
    },
    {
      name: 'type',
      type: 'string',
    },
  ],
  EditToken: [
    {
      name: 'description',
      type: 'string',
    },
    {
      name: 'logo',
      type: 'string',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'ticker',
      type: 'string',
    },
  ],
  FileObject: [
    {
      name: 'fileKey',
      type: 'string',
    },
  ],
  GetAllAssetChanges: [],
  GetAllCashflows: [],
  GetAllReferralLeaders: [],
  GetAllUsers: [],
  GetAssetChangeKyc: [],
  GetAssetChanges: [],
  GetBalance: [],
  // Fee
  GetFee: [],
  // Fund
  GetFund: [],

  GetFundApplication: [],
  // FundRegistration
  GetFundApplications: [],
  GetFundEmployee: [],
  // FundEmployee
  GetFundEmployees: [],
  GetKycStatus: [],
  GetLeaderCashflows: [],
  GetLeaderInvestors: [],
  GetLeaderProfile: [],
  GetOperatorStatus: [],

  GetPoolPrivate: [],
  GetPortfolio: [],
  GetProfile: [],

  // Protocol Actions
  GetQuote: [],

  GetSwap: [],
  // AWS File Storage
  GetUploadUrl: [
    {
      name: 'entityId',
      type: 'string',
    },
    {
      name: 'filename',
      type: 'string',
    },
    {
      name: 'mimetype',
      type: 'string',
    },
    {
      name: 'size',
      type: 'uint256',
    },
    {
      name: 'storageType',
      type: 'string',
    },
  ],
  GetVerification: [
    {
      name: 'address',
      type: 'address',
    },
    {
      name: 'poolAddress',
      type: 'address',
    },
  ],
  // Auth
  Login: [
    {
      name: 'sessionAddress',
      type: 'address',
    },
    {
      name: 'userAddress',
      type: 'address',
    },
    {
      name: 'acceptedTerms',
      type: 'string',
    },
  ],

  Logout: [],
  RequestAssetChange: [
    {
      name: 'fromPoolAddress',
      type: 'address',
    },
    {
      name: 'investorAddress',
      type: 'address',
    },
    {
      name: 'receive',
      type: 'string',
    },
    {
      name: 'tickerFrom',
      type: 'string',
    },
    {
      name: 'tokenAmount',
      type: 'string',
    },
    {
      name: 'type',
      type: 'string',
    },
    {
      name: 'valueTokenAmount',
      type: 'string',
    },
  ],

  StartKyc: [
    {
      name: 'level',
      type: 'string',
    },
  ],
  UpdateFund: [
    {
      name: 'description',
      type: 'string',
    },
    {
      name: 'name',
      type: 'string',
    },
  ],
  UpdateFundApplication: [
    {
      name: 'accountType',
      type: 'string',
    },
    {
      name: 'email',
      type: 'string',
    },
    {
      name: 'ownerName',
      type: 'string',
    },
    {
      name: 'ownerSurname',
      type: 'string',
    },
    {
      name: 'phone',
      type: 'string',
    },
    {
      name: 'telegram',
      type: 'string',
    },
  ],
  // User
  UpdateProfile: [
    {
      name: 'firstName',
      type: 'string',
    },
    {
      name: 'lastName',
      type: 'string',
    },
    {
      name: 'middleName',
      type: 'string',
    },
    {
      name: 'email',
      type: 'string',
    },
    {
      name: 'phone',
      type: 'string',
    },
  ],
  UpdateRefLeaderProfile: [
    {
      name: 'address',
      type: 'address',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'revenueShare',
      type: 'string',
    },
  ],
}
